import { Pipe, PipeTransform } from '@angular/core';
import { format, subDays, subMonths } from 'date-fns';
import {InsightsDateFilterEnums} from "../../enums/profile-enums";

@Pipe({
  name: 'dateRange',
  standalone: true
})
export class DateRangePipe implements PipeTransform {

  transform(date: Date, filter: InsightsDateFilterEnums.lastSevenDays | InsightsDateFilterEnums.lastThirtyDays | InsightsDateFilterEnums.lastThreeMonths | InsightsDateFilterEnums.lastNineMonths | InsightsDateFilterEnums.lastYear): string {
    const endDate = date;
    let startDate: Date;

    // Set the start date based on the filter using date-fns
    switch (filter) {
      case InsightsDateFilterEnums.lastSevenDays:
        startDate = subDays(endDate, 6);
        break;
      case InsightsDateFilterEnums.lastThirtyDays:
        startDate = subDays(endDate, 29);
        break;
      case InsightsDateFilterEnums.lastThreeMonths:
        startDate = subMonths(endDate, 3);
        break;
      case InsightsDateFilterEnums.lastNineMonths:
        startDate = subMonths(endDate, 9);
        break;
      case InsightsDateFilterEnums.lastYear:
        startDate = subMonths(endDate, 12);
        break;
      default:
        return '';
    }

    const startMonth = format(startDate, 'MMMM');
    const endMonth = format(endDate, 'MMMM');
    const startYear = format(startDate, 'yyyy');
    const endYear = format(endDate, 'yyyy');
    const startDay = format(startDate, 'd');
    const endDay = format(endDate, 'd');

    // Check if years are different
    if (startYear !== endYear) {
      return `${startMonth} ${startDay}, ${startYear} - ${endMonth} ${endDay}, ${endYear}`;
    } else {
      return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
    }
  }
}

